export default __webpack_public_path__ + "static/media/ProximaNova-Black.120f91ca.otf";